import { useEffect } from "react";
import { getCurrentLang } from "@/lib/i18n";

export const SITE = "https://aurora-adv.com";
export const ORG = { "@type": "Organization", name: "AURORA-ADV", legalName: "PIXAWEB Sagl", url: SITE };

const upsert = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  return el;
};

const setTag = (attr, key, content) => {
  const el = upsert(`meta[${attr}="${key}"]`, () => Object.assign(document.createElement("meta"), { [attr === "name" ? "name" : "content"]: "" }));
  el.setAttribute(attr, key);
  el.setAttribute("content", content);
};

export const markNoIndex = (title) => {
  document.title = title;
  delete document.documentElement.dataset.seoLang;
  setTag("name", "robots", "noindex, nofollow");
  document.head.querySelector('link[rel="canonical"]')?.remove();
  const ld = document.getElementById("route-jsonld");
  if (ld) ld.textContent = "[]";
};

export const useSeo = ({ title, description, path, jsonld, noindex = false, lang = null, alternates = null }) => {
  useEffect(() => {
    if (lang) document.documentElement.dataset.seoLang = lang;
    else delete document.documentElement.dataset.seoLang;
    document.documentElement.lang = lang || getCurrentLang();
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((l) => l.remove());
    Object.entries(alternates || {}).forEach(([hl, p]) => document.head.appendChild(Object.assign(document.createElement("link"), { rel: "alternate", hreflang: hl, href: `${SITE}${p}` })));
    if (title) document.title = title;
    if (description) { setTag("name", "description", description); setTag("property", "og:description", description); }
    if (title) setTag("property", "og:title", title);
    const url = `${SITE}${path || window.location.pathname}`;
    setTag("property", "og:url", url);
    if (noindex) document.head.querySelector('link[rel="canonical"]')?.remove();
    else upsert('link[rel="canonical"]', () => Object.assign(document.createElement("link"), { rel: "canonical" })).href = url;
    setTag("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    const ld = upsert("script#route-jsonld", () => Object.assign(document.createElement("script"), { id: "route-jsonld", type: "application/ld+json" }));
    ld.textContent = jsonld ? JSON.stringify(jsonld) : "[]";
  }, [title, description, path, jsonld, noindex, lang, alternates]);
};
